import React from 'react';
import HelpIcon from '@material-ui/icons/Help';
import { Tooltip, withStyles } from '@material-ui/core';
import styled from 'styled-components/macro';
import useTranslations from '../hooks/useTranslations';

const Help = styled(HelpIcon)`
  && {
    position: relative;
    top: -0.5em;
    opacity: 0.4;
    font-size: 1em;
    color: ${({ theme }) => theme.palette.primary.main};

    svg {
      font-size: 12px;
    }
  }
`;

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 13
  },
  popper: {
    opacity: 1
  }
}))(Tooltip);

export default ({ title, placement = 'right', children }) => {
  const t = useTranslations();
  return (
    <LightTooltip
      title={children ? children : typeof title === 'string' ? t(title) : title}
      placement={placement}
    >
      <span>
        <Help />
      </span>
    </LightTooltip>
  );
};
